var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTrash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_812_6640)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.1665 10.7917H30.8332",
    stroke: "#2C3E50",
    strokeWidth: 2.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.70752 10.7917L9.24919 29.2917C9.24919 30.1095 9.57404 30.8938 10.1523 31.472C10.7305 32.0502 11.5148 32.3751 12.3325 32.3751H24.6659C25.4836 32.3751 26.2679 32.0502 26.8461 31.472C27.4243 30.8938 27.7492 30.1095 27.7492 29.2917L29.2909 10.7917",
    stroke: "#2C3E50",
    strokeWidth: 2.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.875 10.7917V6.16667C13.875 5.75779 14.0374 5.36566 14.3265 5.07654C14.6157 4.78743 15.0078 4.625 15.4167 4.625H21.5833C21.9922 4.625 22.3843 4.78743 22.6735 5.07654C22.9626 5.36566 23.125 5.75779 23.125 6.16667V10.7917",
    stroke: "#2C3E50",
    strokeWidth: 2.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4165 18.5L21.5832 24.6667M21.5832 18.5L15.4165 24.6667",
    stroke: "#2C3E50",
    strokeWidth: 2.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_812_6640"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrash);
export default __webpack_public_path__ + "static/media/IconTrash.258462e46a3153cbe70e94742e2cb1f5.svg";
export { ForwardRef as ReactComponent };